export default __webpack_public_path__ + "static/media/Designo - Hero.a4299b8c.png";